import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import platform from 'platform';
import { connectionStatus, uccConnectionStatus, cloudConnectionStatus, getJNLP } from '../actions/api/';
import i18next from 'i18next'
import { getLanguage, getLocaleResourcePath, languageSwitchItem } from '../actions/locales'
import { init } from '../actions/stringEncodersFuncs'
import {  setUccConnectionStatus, setCloudConnectionStatus, setIsMobileDevice, setMobileDeviceMode,
		  setVerifyDSOptionsExpand, setVerifyDSExpand, setVerifyDSTextExpand, setCreateDSOptionsExpand,
		  setCreateDSExpand, setCreateDSTextExpand, setEncryptOptionsExpand, setEncryptExpand, setEncryptTextExpand,
		  setEncryptCertExpand,	setDecryptExpand, setDecryptTextExpand, setCreateDSAddToExistExpand, setShowHeader, setUosAgentNativeBuilds } from '../actions/localStates'
import { getURLs, getVersion, getNativeBuildsInfo } from '../actions/api'
import { setURLs, setVersion } from '../actions/localStates'
import HeaderContainer from './HeaderContainer';
import BodyContainer from './BodyContainer';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import '../css/sjwsa-client-0.1.css';

class App extends Component {

	constructor(props) {
    super(props);

		this.showBrowserInfo = this.showBrowserInfo.bind(this)
		this.javaVersion = this.javaVersion.bind(this)
		this.goToMainSite = this.goToMainSite.bind(this)
	}

	componentDidMount() {
		let _this = this

		document.title = i18next.t("serviceTitle");
		const encoded = decodeURI(window.location.search.split('?')[1]);
		if (encoded !== "undefined") {
			let params = new URLSearchParams(document.location.search);
			let headerHide = params.get("headerHide")
			if (headerHide) {
				this.props.actions.setShowHeader(headerHide)
			}
		}

		this.checkConnection = () => {
			_this.props.actions.connectionStatus(_this.props.baseUrls.urlUCC, _this.props.baseUrls.urlCloud, _this.props.mobileModeReducer.isMobileDevice, _this.props.baseUrls.token, _this.props.privateKeyReducer.mobileDSMode)

			if (!_this.props.mobileModeReducer.isMobileDevice) {
				_this.props.actions.uccConnectionStatus(_this.props.baseUrls.urlUCC)
				.then((response) => {
					this.props.actions.setUccConnectionStatus(response)
				});
			}

			_this.props.actions.cloudConnectionStatus(_this.props.baseUrls.urlCloud, _this.props.baseUrls.token)
			.then((response) => {
				this.props.actions.setCloudConnectionStatus(response)
			});
			setTimeout(this.checkConnection, 5000);
		}
		i18next.changeLanguage('uk');

		this.props.actions.getURLs()
		.then((response) => {
			_this.props.actions.setURLs(response)
			// var data = [{
			//             "name" : "windows",
			//             "url" : "https://ccs-dev.cipher.kiev.ua/pcs/native/Agent_UOS_windows-x32_3_0_0-b141.exe"
			//           }, {
			//             "name" : "linux",
			//             "url" : "https://ccs-dev.cipher.kiev.ua/pcs/native/Agent_UOS_unix_3_0_0-b141.sh"
			//           }, {
			//             "name" : "macos",
			//             "url" : "https://ccs-dev.cipher.kiev.ua/pcs/native/Agent_UOS_macos_3_0_0-b141.dmg"
			//           }]
			//           _this.props.actions.setUosAgentNativeBuilds(data)

			if (response.serviceURLs.uosAgentNativeBuilds !== undefined && response.serviceURLs.uosAgentNativeBuilds.baseUrl !== undefined && response.serviceURLs.uosAgentNativeBuilds.baseUrl.length > 0) {
				_this.props.actions.getNativeBuildsInfo(response.serviceURLs.uosAgentNativeBuilds.baseUrl)
				.then((response) => {

					

					if (response !== null && response !== undefined) {
						var reader = new FileReader();
				        reader.readAsBinaryString(response);
				        reader.onload = function (evt) {
				            var data = evt.target.result;
				            var arrayOfStrings = data.split("\n");
				            var sourceObject = []
				            var arrayOfSplittedStrings;

				            for (var i = 0; i < arrayOfStrings.length; i += 1) {
				            	arrayOfSplittedStrings = arrayOfStrings[i].split("=");
				            	if (arrayOfSplittedStrings[0].length > 0) {
				            		sourceObject.push({name: arrayOfSplittedStrings[0], url: _this.props.baseUrls.uosAgentNativeBuilds.baseUrl + "/" + arrayOfSplittedStrings[1]})
				            	}
				            	
				            }
				            _this.props.actions.setUosAgentNativeBuilds(sourceObject)
				        }
				        reader.onerror = function (evt) {
				            document.getElementById("fileContents").innerHTML = "error reading file";
				        }
					}
					
				})
			}
			_this.checkConnection();
			

		})

		this.props.actions.getVersion()
		.then((response) => {
			_this.props.actions.setVersion(response)
		})

		this.props.actions.init()

		this.isMobileDevice = () => {
		    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
		}

		this.props.actions.setIsMobileDevice(this.isMobileDevice())
		this.props.actions.setMobileDeviceMode(this.isMobileDevice())

		if (this.isMobileDevice()) {
			this.props.actions.setVerifyDSOptionsExpand(false)
			this.props.actions.setVerifyDSExpand(true)
			this.props.actions.setVerifyDSTextExpand(true)
			this.props.actions.setCreateDSOptionsExpand(false)
			this.props.actions.setCreateDSExpand(true)
			this.props.actions.setCreateDSTextExpand(true)
			this.props.actions.setEncryptOptionsExpand(false)
			this.props.actions.setEncryptExpand(true)
			this.props.actions.setEncryptTextExpand(true)
			this.props.actions.setEncryptCertExpand(true)
			this.props.actions.setCreateDSAddToExistExpand(true)
			this.props.actions.setDecryptExpand(true)
			this.props.actions.setDecryptTextExpand(true)
		}
	}

	javaVersion() {
	  var result = null;

	  for(var i = 0, size = navigator.mimeTypes.length; i < size; i += 1)
	  {
	      if((result = navigator.mimeTypes[i].type.match(/^application\/x-java-applet;jpi-version=(.*)$/)) !== null)
	          return result[1];
	  }
	  return null;
	}

	showBrowserInfo() {
		var browser, browserVersion;
		try {
		  navigator.userAgentData.getHighEntropyValues(["platformVersion", "uaFullVersion", "fullVersionList"])
			.then(ua => {
			   	if (navigator.userAgentData.platform === "Windows") {
			     	const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
			     	if (majorPlatformVersion >= 13) {
			       		// console.log("Windows 11 or later");
			       		var pltf = platform.os
						pltf.version = "11"
						platform.os = pltf

						if (navigator.userAgentData) {
					        browser = "Microsoft Edge";
					        browserVersion = ua.uaFullVersion;
					    } else {
					        const edgeVersionMatch = /Edg\/(\d+\.\d+\.\d+\.\d+)/.exec(navigator.userAgent);
					        if (edgeVersionMatch) {
					            browser = "Microsoft Edge";
					            browserVersion = edgeVersionMatch[1];
					        }
					    }

					    if (browser !== "Microsoft Edge") {
						    const chromeVersionMatch = /Chrome\/(\d+\.\d+\.\d+\.\d+)/.exec(navigator.userAgent);
						    if (chromeVersionMatch && !/Edg|OPR|Brave/.test(navigator.userAgent)) {
						        browser = "Google Chrome";
						        browserVersion = chromeVersionMatch[1];
						    }

						    if (browser === "Google Chrome") {
						    	function getChromeVersion() {
								    if (navigator.userAgentData !== undefined) {
								        const chromeEntry = ua.fullVersionList.find(entry => entry.brand.includes("Chromium"));
								        return chromeEntry ? chromeEntry.version : "Невідома версія";
								    } else {
								        return getChromeVersionFromUA();
								    }
								}

								function getChromeVersionFromUA() {
								    const match = navigator.userAgent.match(/Chrom(?:e|ium)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/);
								    return match ? match[1] + "." + match[2] + "." + match[3] + "." + match[4] : "Невідома версія";
								}

								function detectChromeVersion() {
								    let browserVersion = getChromeVersion();
								    var vrsn = platform.version
								    vrsn = browserVersion
								    platform.version = vrsn
								    console.log("Chrome Version:", browserVersion);
								}

								detectChromeVersion();

						    }
						} else {
							var vrsn = platform.version
						    vrsn = browserVersion
						    platform.version = vrsn
						}

						alert(''
							+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
							+ 'OS: ' + platform.os
						)
			      	} else {
			        	// console.log("Before Windows 10");
			        	const chromeVersionMatch = /Chrome\/(\d+\.\d+\.\d+\.\d+)/.exec(navigator.userAgent);
					    if (chromeVersionMatch && !/Edg|OPR|Brave/.test(navigator.userAgent)) {
					        browser = "Google Chrome";
					        browserVersion = chromeVersionMatch[1];
					    }

					    if (browser === "Google Chrome") {
					    	function getChromeVersion() {
							    if (navigator.userAgentData !== undefined) {
							        const chromeEntry = ua.fullVersionList.find(entry => entry.brand.includes("Chromium"));
							        return chromeEntry ? chromeEntry.version : "Невідома версія";
							    } else {
							        return getChromeVersionFromUA();
							    }
							}

							function getChromeVersionFromUA() {
							    const match = navigator.userAgent.match(/Chrom(?:e|ium)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/);
							    return match ? match[1] + "." + match[2] + "." + match[3] + "." + match[4] : "Невідома версія";
							}

							function detectChromeVersion() {
							    let browserVersion = getChromeVersion();
							    var vrsn = platform.version
							    vrsn = browserVersion
							    platform.version = vrsn
							    console.log("Chrome Version:", browserVersion);
							}

							detectChromeVersion();

					    }

			        	alert(''
							+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
							+ 'OS: ' + platform.os
						)
			      	}
			   	} else {
			     // console.log("Not running on Windows");
			     	const chromeVersionMatch = /Chrome\/(\d+\.\d+\.\d+\.\d+)/.exec(navigator.userAgent);
				    if (chromeVersionMatch && !/Edg|OPR|Brave/.test(navigator.userAgent)) {
				        browser = "Google Chrome";
				        browserVersion = chromeVersionMatch[1];
				    }

				    if (browser === "Google Chrome") {
				    	function getChromeVersion() {
						    if (navigator.userAgentData !== undefined) {
						        const chromeEntry = ua.fullVersionList.find(entry => entry.brand.includes("Chromium"));
						        return chromeEntry ? chromeEntry.version : "Невідома версія";
						    } else {
						        return getChromeVersionFromUA();
						    }
						}

						function getChromeVersionFromUA() {
						    const match = navigator.userAgent.match(/Chrom(?:e|ium)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/);
						    return match ? match[1] + "." + match[2] + "." + match[3] + "." + match[4] : "Невідома версія";
						}

						function detectChromeVersion() {
						    let browserVersion = getChromeVersion();
						    var vrsn = platform.version
						    vrsn = browserVersion
						    platform.version = vrsn
						    console.log("Chrome Version:", browserVersion);
						}

						detectChromeVersion();

				    }

			     	alert(''
						+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
						+ 'OS: ' + platform.os
					)
			   	}
			});
		} catch (e) {
			alert(''
				+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
				+ 'OS: ' + platform.os
			)
		}

		// const userAgent = navigator.userAgent;

	 //    let os = "";
  //   	let osVersion = "";

		// function getSystemInfo() {
		// 	if (/Windows NT 10.0/.test(userAgent)) {
		//         os = "Windows";
		//         if (navigator.userAgentData !== undefined) {
		//             osVersion = "11";
		//         }
		//     }

		// 	return { os, osVersion };
		// }

		// var tempOs = getSystemInfo()
		// console.log(getSystemInfo());

		// if (window.navigator.userAgentData !== undefined) {
			// window.navigator.userAgentData.getHighEntropyValues(["platformVersion"])
			//  .then(ua => {
			//    if (navigator.userAgentData.platform === "Windows") {
			//      const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
			//      if (majorPlatformVersion >= 13) {
			//       	var pltf = platform.os
			// 		pltf.version = "11"
			// 		platform.os = pltf
			// 		alert(''
			// 			+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
			// 			+ 'OS: ' + platform.os
			// 		)
		 //        } else {
			//         alert(''
			// 			+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
			// 			+ 'OS: ' + platform.os
			// 		)
			//       }
			//    }
			//    else {
			//      alert(''
			// 		+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
			// 		+ 'OS: ' + platform.os
			// 	)
			//    }
			//  });
			// } else {
			// 	alert(''
			// 		+ 'Browser name: ' + platform.name + " " + platform.version + '\n'
			// 		+ 'OS: ' + platform.os
			// 	)
			// }
	}

	goToMainSite () {
		window.open("https://cipher.com.ua/uk", '_blank').focus();
	}

	goToSource (url) {
	    window.open(url, '_blank').focus();
	}

	render() {
		const currentYear = new Date().getFullYear();

		return (
			<div>
				<div className="wrapper">
				{
					<div className={this.props.baseUrls.contrast ? "container grayscale-100" : "container"}>
						{
							!this.props.baseUrls.showHeader
							? <HeaderContainer connectionStatus={this.props.connectionStatus} />
							: <div style={{paddingTop: "10px"}}></div>
						}
						<BodyContainer connectionStatus={this.props.connectionStatus.status} />
					</div>
				}
				{
			        this.props.baseUrls.uosAgentNativeBuilds !== undefined && this.props.baseUrls.uosAgentNativeBuilds.length > 0 && !this.props.mobileModeReducer.isMobileDevice && this.props.baseUrls.bodyIsMounted
			        ? <div className="right-download-panel">
			            {
			              this.props.baseUrls.uosAgentNativeBuilds.map((source) => {
			                var name = "", _this = this, counter = 0;
			                _this.props.baseUrls.uosAgentNativeBuilds.forEach((data) => {
			                	if ((data.name.indexOf("windows32") !== -1) || (data.name.indexOf("windows64") !== -1)) {
			                		counter += 1;
			                	}
			                })

			                name = source.name
			                if (source.name.indexOf("windows32") !== -1) {
			                  name = "windows"
			                }

			                if (source.name.indexOf("windows64") !== -1) {
			                  name = "windows64"
			                }

			                if (source.name.indexOf("linux") !== -1) {
			                  name = "linux"
			                }

			                if (source.name.indexOf("macos") !== -1) {
			                  name = "apple"
			                }

			                return <button className="btn right-download-button" style={{fontSize: "10px", color: "#777"}} onClick={this.goToSource.bind(this, source.url)}><i className={"fa " + "fa-" + (name === "windows64" ? "windows" : name)} style={{fontSize: "1.2rem", color: "#888"}}></i>{name === "windows64" ? "x64" : ((counter > 1 && name === "windows64") || (counter > 1 && name === "windows")) ? "x32" : ""}</button>
			              })
			            }
			            
			          </div>
			        : null
			      }
				</div>
				<div className="footer container" style={{paddingLeft: "30px", fontSize: "14px", color: "rgba(136, 136, 136, 0.61)"}}>
					<div className="row" style={{marginLeft: "0px", marginRight: "0px", paddingRight: "15px"}}>
						<label style={{marginBottom: "0px"}}>©{currentYear} Система криптографічного захисту інформації "Шифр-CaaS"</label>
						<label style={{marginBottom: "0px", marginLeft: "auto"}}>{i18next.t("version")} {this.props.baseUrls.version} {i18next.t("build")} {this.props.baseUrls.build}<i className="fa fa-info-circle" onClick={this.showBrowserInfo} style={{"marginLeft": "7px", "cursor": "pointer"}}></i></label>
					</div>
					<label onClick={this.goToMainSite} style={{display: "block", cursor: "pointer", marginBottom: "0px"}}>Розроблено: Сайфер</label>
				    
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        connectionStatus: state.connectionStatusReucer,
        locales: state.i18n,
        localesReducer: state.localesReducer,
        baseUrls: state.base,
        mobileModeReducer: state.mobileModeReducer,
        privateKeyReducer: state.privateKeyReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    connectionStatus,
	    getLanguage,
	    getLocaleResourcePath,
	    languageSwitchItem,
	    getURLs,
	    setURLs,
	    uccConnectionStatus,
	    cloudConnectionStatus,
	    setUccConnectionStatus,
	    setCloudConnectionStatus,
	    getVersion,
	    setVersion,
	    getJNLP,
	    init,
	    setIsMobileDevice, setMobileDeviceMode,
	    setVerifyDSOptionsExpand,
		setVerifyDSExpand,
		setVerifyDSTextExpand,
		setCreateDSOptionsExpand,
		setCreateDSExpand,
		setCreateDSTextExpand,
		setEncryptOptionsExpand,
		setEncryptExpand,
		setEncryptTextExpand,
		setEncryptCertExpand,
		setDecryptExpand,
		setDecryptTextExpand,
		setCreateDSAddToExistExpand, setShowHeader,
		getNativeBuildsInfo, setUosAgentNativeBuilds
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);